import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2375bfb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "station-form-category-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title" }, "Horário e data", -1))
const _hoisted_3 = { class: "station-form-category-content" }
const _hoisted_4 = {
  key: 0,
  class: "mt-3 transition-all duration-300"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-2 p-3 bg-red-50 border border-red-200 rounded-md flex items-start gap-2 text-red-700 text-sm"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Duração excede o limite permitido"),
  /*#__PURE__*/_createElementVNode("span", null, "A duração do plantão não pode ser superior a 24 horas. Por favor, verifique as datas e horários inseridos.")
], -1))
const _hoisted_7 = {
  key: 1,
  class: "text-red-600 text-sm mt-2 font-medium"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title text-left block mb-2 mt-4" }, "Recorrência", -1))
const _hoisted_10 = { class: "station-form-category-columns justify-start mb-3" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "text-sm text-[#68688D] mt-[-12px]" }

import { reactive, computed, watch } from 'vue'
import { DatePicker } from 'v-calendar'
import {
  mdiCalendarBlankOutline,
  mdiClockOutline,
  mdiPlus,
  mdiClose,
  mdiAlertCircle
} from '@mdi/js'
import { timezones } from '@/hooks/useCommon'
import SelectPositions from './select.positions.vue'
import { ref } from 'vue'
import { format, differenceInMinutes, parse } from 'date-fns'
import {
  getFinishedAtOnPeriodicityChange,
  getFinishedAtOptionsFor,
  getOccurrenceLimitFor,
  getOccurrenceUnitFor,
  periodicityOptions
} from '../../helpers'
import { weekOptions } from '../../../utils/data'
import OptionSelect from '@/components/designSystem/Select/OptionSelect.vue'
import type { StationPeriodicity } from '@/Network/Types/Requests/StationRequests'

enum WeekDaysNumbers {
  'segunda' = '1',
  'terca' = '2',
  'quarta' = '3',
  'quinta' = '4',
  'sexta' = '5',
  'sabado' = '6',
  'domingo' = '0'
}

const DATE_FORMAT = 'dd/MM/yyyy'

type DateInputEvents = Record<string, (event: Event) => void>

/**
 * O `parseDate` do v-calendar termina em `|| new Date(dateString)` (dist/es/index.js:4414):
 * quando a máscara `DD/MM/YYYY` não casa, ele cai no parser leniente do V8, que inventa uma
 * data a partir de texto parcial — `new Date('6')` devolve 01/06/2001. Como o commit do
 * valor acontece no `change` (o `update-on-input` está desligado), basta limpar o texto
 * incompleto antes de entregá-lo à lib.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'hours.and.date.form',
  props: [
  'isUpdateMode',
  'date',
  'endDate',
  'timezone',
  'startHour',
  'endHour',
  'configurationRepetition',
  'periodicity',
  'selectedWeeks',
  'weeksErr',
  'occurrenceErr',
  'valueRepetition',
  'repetitionDays',
  'finishedAt',
  'finishedAtUntil',
  'finishedAtAfter',
  'repetitionErr',
  'schedule',
  'scheduleEndDate',
  'dateErr',
  'startHourErr',
  'endHourErr',
  'endDateErr'
],
  emits: [
  'update:date',
  'update:endDate',
  'update:timezone',
  'update:startHour',
  'update:endHour',
  'update:configurationRepetition',
  'update:periodicity',
  'update:selectedWeeks',
  'update:valueRepetition',
  'update:repetitionDays',
  'update:finishedAt',
  'update:finishedAtUntil',
  'update:finishedAtAfter',
  'update:positionsByRowStations',
  'validation-status'
],
  setup(__props, { emit }) {

const props = __props;




const stationsCountByWeekDays = reactive({
  segunda: 0,
  terca: 0,
  quarta: 0,
  quinta: 0,
  sexta: 0,
  sabado: 0,
  domingo: 0
})

const parseDateTime = (dateStr: string, timeStr: string): Date | null => {
  if (!dateStr || !timeStr) return null

  try {
    const dateTimeString = `${dateStr} ${timeStr}`
    const parsedDate = parse(dateTimeString, 'dd/MM/yyyy HH:mm', new Date())

    return isNaN(parsedDate.getTime()) ? null : parsedDate
  } catch (e) {
    return null
  }
}

const startDateTime = computed(() => parseDateTime(props.date, props.startHour))
const endDateTime = computed(() => parseDateTime(props.endDate, props.endHour))

const areAllFieldsPresent = computed(() => {
  return !!(props.startHour && props.endHour && props.date && props.endDate)
})

const isFormatValid = computed(() => {
  if (!areAllFieldsPresent.value) return true
  return !!(startDateTime.value && endDateTime.value)
})

const isIntervalValid = computed(() => {
  if (!isFormatValid.value) return true
  if (!startDateTime.value || !endDateTime.value) return true
  return endDateTime.value > startDateTime.value
})

const calculatedDuration = computed(() => {
  if (!startDateTime.value || !endDateTime.value) return null
  if (!isIntervalValid.value) return null

  const totalMinutes = differenceInMinutes(endDateTime.value, startDateTime.value)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  const MS_IN_24_HOURS = 24 * 60 * 60 * 1000
  const msDiff = endDateTime.value.getTime() - startDateTime.value.getTime()
  const isOver24h = msDiff > MS_IN_24_HOURS

  const formattedMinutes = minutes > 0 ? `${minutes}m` : ''
  const formattedDuration = `${hours}h ${formattedMinutes}`.trim()

  return {
    text: formattedDuration,
    isOver24h
  }
})

const validationError = computed((): string | null => {
  if (!props.isUpdateMode && !areAllFieldsPresent.value) {
    return 'INCOMPLETE'
  }

  if (areAllFieldsPresent.value) {
    if (!isFormatValid.value) {
      return 'Formato de data ou hora inválido.'
    }
    if (!isIntervalValid.value) {
      return 'O horário final não pode ser anterior ou igual ao horário inicial.'
    }

    // Regra FatFinger: Duração máxima de 24 horas
    if (calculatedDuration.value?.isOver24h) {
      return 'A duração do plantão não pode ser superior a 24 horas.'
    }
  }

  return null
})

watch(
  validationError,
  (currentError) => {
    const isValid = currentError === null

    emit('validation-status', {
      isValid: isValid,
      message: currentError === 'INCOMPLETE' ? null : currentError
    })
  },
  {
    immediate: true
  }
)

const positionsByRowStations = ref<Array<number | null>>([])

const biggerCountFromWeekDays = computed(() => {
  return Math.max(...Object.values(stationsCountByWeekDays))
})

const occurrenceUnit = computed(() => getOccurrenceUnitFor(props.periodicity))
const occurrenceMax = computed(() => getOccurrenceLimitFor(props.periodicity).max)

const formattedScheduleEndDate = computed(() => {
  if (props.scheduleEndDate) {
    try {
      return format(new Date(props.scheduleEndDate), DATE_FORMAT)
    } catch (e) {
      return 'Data inválida'
    }
  }
  return 'Não definida'
})

/**
 * Só `dd/MM/yyyy` completo conta como data digitada. `parse` do date-fns sozinho não
 * basta: ele aceita `5/10/26` e devolve o ano 26.
 */
const STRICT_DATE_PATTERN = /^\d{2}\/\d{2}\/\d{4}$/

const isTypedDateComplete = (text: string) =>
  STRICT_DATE_PATTERN.test(text) && !isNaN(parse(text, DATE_FORMAT, new Date()).getTime())

/**
 * `'dd/MM/yyyy'` -> `Date`, e qualquer outra coisa -> `null`.
 *
 * Substitui o `new Date(str.split('/').reverse().join('-') + 'T12:00:00')`, que devolvia
 * `Invalid Date` para texto parcial. Esse `Invalid Date` voltava como `model-value` do
 * picker, o v-calendar zerava o `inputValues` e o campo esvaziava na tela enquanto o
 * estado do pai seguia preenchido.
 */
const toPickerDate = (value?: string | null): Date | null => {
  if (!value) return null
  const parsed = parse(value, DATE_FORMAT, new Date())
  return isNaN(parsed.getTime()) ? null : parsed
}

const startDateModel = computed(() => toPickerDate(props.date))
const endDateModel = computed(() => toPickerDate(props.endDate))

const guardDateInput = (events: DateInputEvents): DateInputEvents => ({
  ...events,
  change: (event: Event) => {
    const input = event.currentTarget as HTMLInputElement
    const text = input.value.trim()
    if (text && !isTypedDateComplete(text)) {
      input.value = ''
      // O `<v-text-field>` guarda o texto digitado internamente; sem re-emitir `input`
      // ele continuaria exibindo o valor descartado, que é a mesma dessincronia
      // tela/estado que este fix resolve.
      input.dispatchEvent(new Event('input'))
    }
    events.change?.(event)
  }
})

/**
 * Único ponto de escrita das datas no estado do pai: só o `<DatePicker>` emite, e sempre
 * como `Date | null`. `null` (campo apagado ou texto inválido no blur) zera o estado nos
 * dois campos — antes `setDate` fazia `if (!v) return` e retinha no pai uma data que já
 * não estava mais na tela.
 */
const emitDate = (event: 'update:date' | 'update:endDate', value: Date | null) => {
  if (!value || isNaN(value.getTime())) {
    emit(event, '')
    return
  }
  // Sem `value.setHours(12, 0, 0, 0)`: `value` é o `dateValue` interno do v-calendar, e a
  // mutação corrompia o estado da lib. `format` só lê a parte de data.
  emit(event, format(value, DATE_FORMAT))
}

const setDate = (v: Date | null) => emitDate('update:date', v)
const setEndDate = (v: Date | null) => emitDate('update:endDate', v)

const setTimezone = (v: string) => emit('update:timezone', v)
const setStartHour = (v: string) => emit('update:startHour', v)
const setEndHour = (v: string) => emit('update:endHour', v)
const setConfigurationRepetition = (v: string) => {
  return emit('update:configurationRepetition', v)
}

const setFinishedAt = (v: string) => {
  emit('update:finishedAt', v)
}

const setFinishedAtUntil = (v: Date | string) => {
  if (!v) return
  const formattedDate =
    typeof v === 'string' ? v : format(new Date(v.setHours(12, 0, 0, 0)), DATE_FORMAT)
  emit('update:finishedAtUntil', formattedDate)
}
const setFinishedAtAfter = (v: string) => emit('update:finishedAtAfter', v)

const setPeriodicity = (v: StationPeriodicity) => {
  emit('update:periodicity', v)
  if (v !== 'MONTHLY_ABCDE') emit('update:selectedWeeks', [])
  const finishedAtChange = getFinishedAtOnPeriodicityChange(v, props.finishedAt)
  if (finishedAtChange) {
    emit('update:finishedAt', finishedAtChange.finishedAt)
    emit('update:finishedAtAfter', finishedAtChange.finishedAtAfter)
  }
}

const setSelectedWeeks = (v: string[]) => emit('update:selectedWeeks', v)

function buildRepetionDays(weekDays: typeof stationsCountByWeekDays): Record<string, string> {
  return Object.keys(weekDays).reduce(
    (acc, day) => {
      const dayNumber = WeekDaysNumbers[day as keyof typeof WeekDaysNumbers]
      acc[dayNumber] = String(weekDays[day as keyof typeof weekDays])
      return acc
    },
    {} as Record<string, string>
  )
}

const setRepetitionDays = () => {
  const repetionDays = buildRepetionDays(stationsCountByWeekDays)
  emit('update:repetitionDays', repetionDays)
}

const addStationInWeekDay = (weekDay) => {
  stationsCountByWeekDays[weekDay] += 1
  setRepetitionDays()
}

const removeStationInWeekDay = (weekDay) => {
  stationsCountByWeekDays[weekDay] -= 1
  positionsByRowStations.value.pop()
  // positionsByRowStations.value = popped
  setRepetitionDays()
}

const onSelectPosition = (e, rowIndex) => {
  //adicionar no objeto o ID da position pra vincular na vaga.
  positionsByRowStations.value[rowIndex] = e
  setRepetitionDays()
  emit('update:positionsByRowStations', positionsByRowStations.value)
}

// const onSelectPositionNoRepeat = (e, rowIndex) => {
//   positionsByRowStations.value[rowIndex] = e
//   //adicionar no objeto o ID da position pra vincular na vaga.
//   emit('update:positionsByRowStations', [e])
// }

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DatePicker), {
                "onUpdate:modelValue": setDate,
                "model-value": startDateModel.value,
                locale: "pt-BR",
                masks: { input: `DD/MM/YYYY` },
                "max-date": __props.scheduleEndDate ? new Date(__props.scheduleEndDate) : null,
                "initial-page": { month: new Date().getMonth() + 1, year: new Date().getFullYear() },
                "update-on-input": false
              }, {
                default: _withCtx(({ inputValue, inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    "data-testid": "station-start-date-input",
                    "model-value": inputValue
                  }, _toHandlers(guardDateInput(inputEvents)), {
                    label: "Data de Início",
                    "append-inner-icon": _unref(mdiCalendarBlankOutline),
                    color: "primary20",
                    variant: "outlined",
                    density: "comfortable",
                    "error-messages": __props.dateErr
                  }), null, 16, ["model-value", "append-inner-icon", "error-messages"])
                ]),
                _: 1
              }, 8, ["model-value", "max-date", "initial-page"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_v_text_field, {
                "append-inner-icon": _unref(mdiClockOutline),
                "onUpdate:modelValue": setStartHour,
                "model-value": __props.startHour,
                label: "Hora de Início",
                color: "primary20",
                variant: "outlined",
                density: "comfortable",
                "error-messages": __props.startHourErr
              }, null, 8, ["append-inner-icon", "model-value", "error-messages"]), [
                [_directive_maska, '##:##']
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DatePicker), {
                "onUpdate:modelValue": setEndDate,
                locale: "pt-BR",
                "model-value": endDateModel.value,
                masks: { input: `DD/MM/YYYY` },
                "max-date": __props.scheduleEndDate ? new Date(__props.scheduleEndDate) : null,
                "initial-page": { month: new Date().getMonth() + 1, year: new Date().getFullYear() },
                "update-on-input": false
              }, {
                default: _withCtx(({ inputValue, inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    "data-testid": "station-end-date-input",
                    "model-value": inputValue
                  }, _toHandlers(guardDateInput(inputEvents)), {
                    label: "Data de Fim",
                    "append-inner-icon": _unref(mdiCalendarBlankOutline),
                    color: "primary20",
                    variant: "outlined",
                    density: "comfortable",
                    "error-messages": __props.endDateErr
                  }), null, 16, ["model-value", "append-inner-icon", "error-messages"])
                ]),
                _: 1
              }, 8, ["model-value", "max-date", "initial-page"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_v_text_field, {
                "append-inner-icon": _unref(mdiClockOutline),
                "onUpdate:modelValue": setEndHour,
                "model-value": __props.endHour,
                label: "Hora de Fim",
                color: "primary20",
                variant: "outlined",
                density: "comfortable",
                "error-messages": __props.endHourErr
              }, null, 8, ["append-inner-icon", "model-value", "error-messages"]), [
                [_directive_maska, '##:##']
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12",
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_autocomplete, {
                "onUpdate:modelValue": setTimezone,
                items: _unref(timezones),
                "model-value": __props.timezone,
                color: "primary20",
                label: "Fuso Horário",
                variant: "outlined",
                density: "comfortable",
                "auto-select-first": true,
                class: "!w-full"
              }, {
                item: _withCtx(({ props, item }) => [
                  _createVNode(_component_v_list_item, _mergeProps(props, {
                    title: item?.raw?.title,
                    subtitle: item?.raw?.subtitle
                  }), null, 16, ["title", "subtitle"])
                ]),
                _: 1
              }, 8, ["items", "model-value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (calculatedDuration.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center text-sm font-bold", calculatedDuration.value.isOver24h ? 'text-red-600' : 'text-gray-600'])
            }, [
              (calculatedDuration.value.isOver24h)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    icon: _unref(mdiAlertCircle),
                    size: "small",
                    class: "mr-1"
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              _createTextVNode(" Duração calculada: " + _toDisplayString(calculatedDuration.value.text), 1)
            ], 2),
            (calculatedDuration.value.isOver24h)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiAlertCircle),
                    size: "small",
                    class: "mt-0.5"
                  }, null, 8, ["icon"]),
                  _hoisted_6
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (
          validationError.value &&
          validationError.value !== 'A duração do plantão não pode ser superior a 24 horas.'
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(validationError.value !== 'INCOMPLETE' ? validationError.value : ''), 1))
        : _createCommentVNode("", true),
      (!__props.isUpdateMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_v_radio_group, {
                "onUpdate:modelValue": setConfigurationRepetition,
                "model-value": __props.configurationRepetition,
                inline: "",
                class: "flex justify-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_radio, {
                    label: "Não se repete",
                    color: "primary",
                    value: "no-repeat"
                  }),
                  _createVNode(_component_v_radio, {
                    label: "Repetir",
                    color: "primary",
                    value: "daily"
                  })
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            (__props.configurationRepetition !== 'no-repeat')
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "5" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          label: "Periodicidade",
                          "data-testid": "select-periodicity",
                          "onUpdate:modelValue": setPeriodicity,
                          items: _unref(periodicityOptions),
                          "model-value": __props.periodicity,
                          color: "primary20",
                          density: "comfortable"
                        }, null, 8, ["items", "model-value"])
                      ]),
                      _: 1
                    }),
                    (__props.periodicity === 'MONTHLY_ABCDE')
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "7"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(OptionSelect, {
                              label: "Semanas do mês",
                              options: _unref(weekOptions),
                              "model-value": __props.selectedWeeks,
                              multiple: "",
                              "error-messages": __props.weeksErr,
                              "onUpdate:modelValue": setSelectedWeeks
                            }, null, 8, ["options", "model-value", "error-messages"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.configurationRepetition !== 'no-repeat')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_v_row, { class: "gap-2 w-100" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "flex-nowrap gap-2 min-h-36"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "stations-cols position-col" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "card-position mb-2",
                                title: "Posição",
                                disabled: ""
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(biggerCountFromWeekDays.value), (v, i) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: 'position-' + i,
                                  class: "card-position mb-2"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createBlock(SelectPositions, {
                                      class: "select-position-bulk ml-2",
                                      key: `sposition-${__props.schedule || 0}`,
                                      "schedule-id": __props.schedule,
                                      modelValue: positionsByRowStations.value[i],
                                      "onUpdate:modelValue": ($event: any) => ((positionsByRowStations.value[i]) = $event),
                                      onOnSelect: ($e) => onSelectPosition($e, i),
                                      variant: "plain"
                                    }, null, 8, ["schedule-id", "modelValue", "onUpdate:modelValue", "onOnSelect"]))
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "stations-cols" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (addStationInWeekDay('segunda'))),
                                class: "card-station card-header",
                                title: "Segunda",
                                link: ""
                              }, {
                                subtitle: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: _unref(mdiPlus),
                                    small: "",
                                    color: "black"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(stationsCountByWeekDays.segunda), (v, i) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: 'segunda-' + i,
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (removeStationInWeekDay('segunda'))),
                                  class: "card-station card-new-station",
                                  link: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: _unref(mdiClose),
                                      size: "x-small",
                                      color: "black",
                                      class: "vaga-icon-close"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" Vaga ")
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "stations-cols" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (addStationInWeekDay('terca'))),
                                class: "card-station card-header",
                                title: "Terça",
                                link: ""
                              }, {
                                subtitle: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: _unref(mdiPlus),
                                    small: "",
                                    color: "black"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(stationsCountByWeekDays.terca), (v, i) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: 'terca-' + i,
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (removeStationInWeekDay('terca'))),
                                  class: "card-station card-new-station",
                                  link: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: _unref(mdiClose),
                                      size: "x-small",
                                      color: "black",
                                      class: "vaga-icon-close"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" Vaga ")
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "stations-cols" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (addStationInWeekDay('quarta'))),
                                class: "card-station card-header",
                                title: "Quarta",
                                link: ""
                              }, {
                                subtitle: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: _unref(mdiPlus),
                                    small: "",
                                    color: "black"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(stationsCountByWeekDays.quarta), (v, i) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: 'quarta-' + i,
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (removeStationInWeekDay('quarta'))),
                                  class: "card-station card-new-station",
                                  link: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: _unref(mdiClose),
                                      size: "x-small",
                                      color: "black",
                                      class: "vaga-icon-close"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" Vaga ")
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "stations-cols" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (addStationInWeekDay('quinta'))),
                                class: "card-station card-header",
                                title: "Quinta",
                                link: ""
                              }, {
                                subtitle: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: _unref(mdiPlus),
                                    small: "",
                                    color: "black"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(stationsCountByWeekDays.quinta), (v, i) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: 'quinta-' + i,
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (removeStationInWeekDay('quinta'))),
                                  class: "card-station card-new-station",
                                  link: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: _unref(mdiClose),
                                      size: "x-small",
                                      color: "black",
                                      class: "vaga-icon-close"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" Vaga ")
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "stations-cols" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (addStationInWeekDay('sexta'))),
                                class: "card-station card-header",
                                title: "Sexta",
                                link: ""
                              }, {
                                subtitle: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: _unref(mdiPlus),
                                    small: "",
                                    color: "black"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(stationsCountByWeekDays.sexta), (v, i) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: 'sexta-' + i,
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (removeStationInWeekDay('sexta'))),
                                  class: "card-station card-new-station",
                                  link: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: _unref(mdiClose),
                                      size: "x-small",
                                      color: "black",
                                      class: "vaga-icon-close"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" Vaga ")
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "stations-cols" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (addStationInWeekDay('sabado'))),
                                class: "card-station card-header",
                                title: "Sábado",
                                link: ""
                              }, {
                                subtitle: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: _unref(mdiPlus),
                                    small: "",
                                    color: "black"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(stationsCountByWeekDays.sabado), (v, i) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: 'sabado-' + i,
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (removeStationInWeekDay('sabado'))),
                                  class: "card-station card-new-station",
                                  link: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: _unref(mdiClose),
                                      size: "x-small",
                                      color: "black",
                                      class: "vaga-icon-close"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" Vaga ")
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "stations-cols" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (addStationInWeekDay('domingo'))),
                                class: "card-station card-header",
                                title: "Domingo",
                                link: ""
                              }, {
                                subtitle: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: _unref(mdiPlus),
                                    small: "",
                                    color: "black"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(stationsCountByWeekDays.domingo), (v, i) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: 'domingo-' + i,
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (removeStationInWeekDay('domingo'))),
                                  class: "card-station card-new-station",
                                  link: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: _unref(mdiClose),
                                      size: "x-small",
                                      color: "black",
                                      class: "vaga-icon-close"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" Vaga ")
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (__props.configurationRepetition !== 'no-repeat')
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 2,
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "5" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          label: "Repetir",
                          "data-testid": "station-finished-at-select",
                          "onUpdate:modelValue": setFinishedAt,
                          items: _unref(getFinishedAtOptionsFor)(__props.periodicity),
                          "model-value": __props.finishedAt,
                          color: "primary20",
                          density: "comfortable"
                        }, null, 8, ["items", "model-value"]),
                        _createElementVNode("p", _hoisted_12, [
                          _createTextVNode(" Final configurado da escala: "),
                          _createElementVNode("b", null, _toDisplayString(formattedScheduleEndDate.value), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "7" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DatePicker), {
                          "onUpdate:modelValue": setFinishedAtUntil,
                          "model-value": __props.finishedAtUntil,
                          locale: "pt-BR",
                          masks: { input: `DD MMM YYYY` },
                          "max-date": __props.scheduleEndDate ? new Date(__props.scheduleEndDate) : null,
                          "initial-page": { month: new Date().getMonth() + 1, year: new Date().getFullYear() }
                        }, {
                          default: _withCtx(({ inputValue, inputEvents }) => [
                            (__props.finishedAt === 'until')
                              ? (_openBlock(), _createBlock(_component_v_text_field, _mergeProps({
                                  key: 0,
                                  placeholder: "Range",
                                  "append-inner-icon": _unref(mdiCalendarBlankOutline),
                                  value: inputValue
                                }, _toHandlers(inputEvents), {
                                  density: "comfortable",
                                  class: "w-full",
                                  color: "primary20"
                                }), null, 16, ["append-inner-icon", "value"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["model-value", "max-date", "initial-page"]),
                        (__props.finishedAt === 'occurrence')
                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                              key: 0,
                              "onUpdate:modelValue": setFinishedAtAfter,
                              "model-value": __props.finishedAtAfter,
                              type: "number",
                              density: "comfortable",
                              placeholder: occurrenceUnit.value.placeholder,
                              class: "w-full",
                              color: "primary20",
                              suffix: occurrenceUnit.value.suffix,
                              min: 1,
                              max: occurrenceMax.value,
                              "error-messages": __props.occurrenceErr
                            }, null, 8, ["model-value", "placeholder", "suffix", "max", "error-messages"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})